<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t($route.name))"
      icon="mdi-cash-clock"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      :create-label="$t('new')"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo('academyCategory')"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        :data="excelItems"
        worksheet="abriron.com"
        name="data.xls"
        type="xls"
        ref="refExcel"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      </template>
      <template #bulk>
      <button
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-column-resize="academyTeacherCostColumnPlugins"
        v-column-drag="academyTeacherCostColumnPlugins"
        v-column-pin="academyTeacherCostColumnPlugins"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        v-model="selected"
        :headers="tableHeaders"
        :items="items"
        :page.sync="page"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="false"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-0"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
            <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                class="pl-action-cell__btn" icon x-small
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
                        <v-list dense>
              <v-list-item
                link
                @click="goAttendance(item)"
              >
                <v-list-item-icon>
                  <v-icon class="mt-2">
                    mdi-format-list-checks
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('academyStudentAttendance', {name: $store.state.studentLabel})" />
              </v-list-item>
              <v-list-item
                link
                @click="studentList(item)"
              >
                <v-list-item-icon>
                  <v-icon class="mt-2">
                    mdi-account-school-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('academyStudentList', {name: $store.state.studentLabel})" />
              </v-list-item>
              <v-list-item
                v-if="!item.status"
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
            <span class="pl-action-cell__row"><a>
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </a></span>
          </div>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.sum_cost="{ item }">
            {{ $numberFormat(parseFloat(item.sum_cost)) }} {{ $store.state.currencySymbol }}
        </template>
        <template v-slot:item.name="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                color="primary"
                text
                small
                v-on="on"
              >
                {{ item.event.name }}
              </v-btn>
            </template>
          </v-tooltip>
        </template>
        <template v-slot:item.id="{ item }">
          <a>
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.arrayDays="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(day, index) in item.arrayDays"
              :key="index"
              color="primary"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ $t(day) }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="item.tags || []" />
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:body.append>
          <tr
            v-if="isMobile || mobileShow"
            :class="{'v-data-table__mobile-table-row':isMobile}"
          >
            <td
              :colspan="isMobile ? 6 : Number(showHeaders.length) - 2"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="isMobile ? 6 : 1"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('count') + ':' : '') }} {{ $numberFormat(totals.count) }}
            </td>
            <td
              :colspan="isMobile ? 6 : 1"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('amount') + ':' : '') }} {{ $numberFormat(totals.amount) }}
              {{ ($store.state.currency ? $store.state.currency.symbol : '') }}
            </td>
          </tr>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <div
            v-if="!isMobile && !mobileShow"
            class="app-list-page-totals"
          >
            <span class="app-list-page-totals__label">{{ $t("sum") }}</span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t("sessionCount") }}</span>
              <span class="app-list-page-totals__val">{{ $numberFormat(totals.count) }}</span>
            </span>
            <span class="app-list-page-totals__item app-list-page-totals__item--final">
              <span class="app-list-page-totals__key">{{ $t("amount") }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.amount) }}
                {{ ($store.state.currency ? $store.state.currency.symbol : '') }}
              </span>
            </span>
          </div>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t($route.name))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      :create-label="$t('new')"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo('academyCategory')"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t($route.name))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ $t("academyTeacherSessionCostListFilterTitle") }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-account-tie-outline</v-icon>
              {{ $t("academyFilterBasics") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="event"
                title="academyEventName"
                type="academyEvent"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="teacher"
                title="teacher"
                type="person"
                :new-btn="true"
                :data="JSON.stringify({type: 'teacher'})"
              />

              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>

            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-calendar-range</v-icon>
              {{ $t("accFilterDateTime") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <div>
                <v-text-field
                  id="fromId"
                  v-model="fromDate"
                  :label="$t('from') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-start"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="fromDate"
                  element="fromId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toId"
                  v-model="toDate"
                  :label="$t('until') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-end"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="toDate"
                  element="toId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  :min="fromDate"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                :loading="loading"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="product"
            :get-item="uploadDialog"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="sessionModal"
      width="500px"
    >
      <session-modal
        :selected-event="sessionSelect"
        @close="sessionModal = false"
        :hideBarBtnProp="true"
      />
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </div>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import General from '../../../../Mixins/general'
  import Upload from '../../components/general/upload/upload'
  import SessionModal from './partial/sessionModal'
  import {
    applyColumnSettings,
    loadColumnSettings,
  } from '@/plugins/columnSettings/columnSettings'
  import { reorderPinnedHeaders } from '@/plugins/columnPin/columnPin'
  import ProList from "@/Mixins/proList";
  import ProListFrame from "@/components/proList/ProListFrame.vue";
  import ProListMobile from "@/components/proList/ProListMobile.vue";
  import PrintStudio from "@/modules/print/PrintStudio.vue";
  export default {
    name: 'academyTeacherSessionCostList',
    components: {
      ProListFrame,
      ProListMobile,
      PrintStudio,
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Upload,
      Print,
      SessionModal,
      Task,
    },
    mixins: [General, ProList],
    props: ['input', 'type', 'refId', 'eventProp', 'teacherProp'],
    data: () => ({
      selected: [],
      inventoryStatus: null,
      inventoryStatusItems: null,
      group: null,
      sessionStatus: null,
      teacher: null,
      event: null,
      fromDate: null,
      toDate: null,
      status: null,
      excelItems: [],
      cat1: null,
      cat2: null,
      registerar: null,
      selectedHeaders: [],
      sessionSelect: null,
      sessionModal: false,
      uploadDialog: false,
      printDialog: false,
      deletDialog: false,
      showSelect: false,
      filter: false,
      productStatus: null,
      model: null,
      from: 1,
      pageCount: 1,
      page: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      // excelItems: [],
      search: null,
    }),
    computed: {

      activeFilterChips () {
        var app = this

      var has = function (v) {
        if (Array.isArray(v)) return v.length > 0
        return v !== null && v !== undefined && v !== '' && v !== '0' && v !== 0
      }
      var show = function (v) {
        if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0])
        if (v && typeof v === 'object') return v.name || v.text || v.label || ''
        return typeof v === 'number' || typeof v === 'string' ? String(v) : ''
      }

        var defs = [
          ['event', app.$t('academyEventName')],
          ['teacher', app.$t('teacher')],
          ['fromDate', app.$t('from') + ' ' + app.$t('date')],
          ['toDate', app.$t('until') + ' ' + app.$t('date')],
        ]
        return defs
          .filter(function (d) {
            return has(app[d[0]])
          })
          .map(function (d) {
            return { key: d[0], label: d[1], value: d.length > 2 ? d[2] : show(app[d[0]]) }
          })
      },
      proListKey () {
        return this.academyTeacherCostColumnPersistKey
      },
      proListLocked () {
        return this.academyTeacherCostLockedColumns
      },
      academyTeacherCostColumnPersistKey () {
        return 'academy-teacher-session-cost-list-columns'
      },
      academyTeacherCostLockedColumns () {
        var locked = ['actions', 'teacher.name']
        return this.showSelect ? ['__select'].concat(locked) : locked
      },
      academyTeacherCostColumnPlugins () {
        var selectHeader = {
          value: '__select',
          text: '',
          width: 32,
          sortable: false,
          pinned: false,
          originalIndex: -1,
        }
        var visible = this.showSelect
          ? [selectHeader].concat(this.tableHeaders || [])
          : this.tableHeaders || []
        return {
          headers: this.headers,
          visibleHeaders: visible,
          locked: this.academyTeacherCostLockedColumns,
          anchor: 'teacher.name',
          minWidth: 60,
          persistKey: this.academyTeacherCostColumnPersistKey,
        }
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.typeForm === 'service') {
            if (s.value === 'stock' || s.value === 'order_point') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      totals: function () {
        const totals = this.items.reduce((acc, d, index) => {
          acc.amount += parseFloat(d.sum_cost)
          acc.count += d.count_session
          return acc
        }, {
          amount: 0,
          count: 0,
        })
        return totals
      },
    },
    watch: {
      refId (val, oldVal) {
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated () {
      // this.getItems()
    },
    beforeMount () {
      this.headers = [
        {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
        {
          text: this.$t('teacher'),
          sortable: true,
          value: 'teacher.name',
          table: 'users.name',
        },
        {
          text: this.$t('academyEventName'),
          sortable: true,
          value: 'name',
          table: 'academy_category.name',
        },
        {
          text: this.$t('place'),
          sortable: true,
          value: 'place.name',
          table: 'academy_places.name',
        },
        {
          text: this.$t('startDate'),
          sortable: false,
          value: 'event.start_date',
        },
        {
          text: this.$t('startTime'),
          sortable: true,
          value: 'start_time',
          table: 'academy_events.start_time',
        },
        {
          text: this.$t('duration'),
          sortable: true,
          value: 'duration',
          table: 'academy_events.duration',
        },
        {
          text: this.$t('sessionCount'),
          sortable: false,
          value: 'count_session',
        },
        {
          text: this.$t('sum'),
          sortable: false,
          value: 'sum_cost',
        },
      ]
      this.statusItems = [
        {
          value: 'not-held',
          text: this.$t('not-held'),
        },
        {
          value: 'done',
          text: this.$t('done'),
        },
        {
          value: 'canceled',
          text: this.$t('canceled'),
        },
      ]
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      reorderPinnedHeaders(this.headers, {
        locked: this.academyTeacherCostLockedColumns,
        anchor: 'teacher.name',
      })
      this.loadAcademyTeacherCostColumnSettings()
    },
    mounted () {
      if (this.teacherProp) {
        this.teacher = this.teacherProp
      }
      this.getItems()
    },
    methods: {

      resetFilters () {
        var app = this
        ;['event', 'teacher', 'fromDate', 'toDate'].forEach(function (k) { app[k] = null })
      },
      loadAcademyTeacherCostColumnSettings () {
        var app = this
        if (!app.headers || !app.headers.length) return
        loadColumnSettings(app, app.academyTeacherCostColumnPersistKey).then(function (snapshot) {
          if (!snapshot || !snapshot.length) return
          applyColumnSettings(app.headers, snapshot, {
            locked: app.academyTeacherCostLockedColumns,
            anchor: 'teacher.name',
          })
          app.$forceUpdate()
        })
      },
      openSessionModal (item) {
        this.sessionSelect = item
        this.sessionModal = true
      },
      goAttendance (item) {
        this.$router.push({ name: 'academyStudentAttendance', params: { sessionProp: item } })
      },
      studentList (item) {
        this.$router.push({ name: 'academyEventStudent', params: { eventProp: item.event } })
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openUploadDialog (item) {
        this.uploadDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'academyEventEdit', params: { id: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'academySession', {
          params: {
            teacherSessionCost: 'active',
            registerar: app.registerar,
            fromDate: app.fromDate,
            toDate: app.toDate,
            teacher: app.teacher,
            search: app.search,
            page: (app.allRows ? app.excelPage : app.options.page),
            refId: app.refId,
            sortBy: app.sortBy,
            status: app.status,
            event: app.event,
            eventProp: app.eventProp,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.last_page = res.last_page
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'academySession/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push({ id: value.id })
        })
        app.$axios.get(this.$endpoint + 'academySession', {
          params: {
            deleteItems: selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            name: String(d.teacher.name),
            event: (d.event ? d.event.name : ''),
            start_date: (d.event ? d.event.start_date : ''),
            start_time: (d.event ? d.event.start_time : ''),
            count: d.count_session,
            sum: d.sum_cost,
          })
        })
      },
    },
  }
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";


</style>
